module.exports = __webpack_public_path__ + "static/blog11-e28a58ae09d7f4b9c7823f67714ae15f.png";